import React, { useState, useEffect } from 'react';
import { ItemProps, TaskTypeProps } from './types';
import strings from '../../resources/strings';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { FormControl, Grid, InputLabel, MenuItem } from '@mui/material';
import { getInstance } from './TaskTypesFactory';
import { Option } from '../../store/tasks/types';
import DeleteCircleButton from '../Buttons/DeleteCircleButton';

const TaskItem: React.FC<ItemProps> = (props) => {
    const [options, setOptions] = useState<Option[]>([]);

    useEffect(() => {
        if (options.length > 0)
            props.setTasks(
                props.tasks.map((item) => {
                    return item.id !== props.task.id ? item : { ...props.task, options: options };
                }),
            );
    }, [options]);

    useEffect(() => {
        if (props.task.options && props.task.options.length > 0) setOptions(props.task.options);
    }, [props.task.options]);

    const handleChangeTaskType = (event: SelectChangeEvent) => {
        const selectedType = event.target.value;
        const modified = props.tasks.map((item) => {
            return item.id !== props.task.id ? item : { ...item, type: selectedType, description: {}, image: '' };
        });
        props.setTasks(modified);
    };

    const getSelectOptions = () => {
        return props.taskTypes.map((item, index) => {
            return (
                <MenuItem key={index} value={item.id}>
                    {item.name[props.language]}
                </MenuItem>
            );
        });
    };

    return (
        <div className="task-item">
            <Grid container>
                <Grid item xs={6}>
                    <div className="task-label">
                        {strings.tasks.taskLabel} {props.index}
                    </div>
                    <FormControl className="task-type-selector">
                        <InputLabel id={`${props.task.id}_taskType_${props.language}`}>Step type</InputLabel>
                        <Select
                            labelId={`${props.task.id}_taskType_${props.language}`}
                            id={`${props.task.id}_taskType_${props.language}`}
                            value={props.task.type}
                            label="Step type"
                            onChange={handleChangeTaskType}
                        >
                            {getSelectOptions()}
                        </Select>
                    </FormControl>
                    {props.deleteEnabled ? (
                        <DeleteCircleButton
                            action={() => {
                                props.deleteTask(props.task.id);
                            }}
                            size="large"
                        ></DeleteCircleButton>
                    ) : (
                        ''
                    )}
                </Grid>
                <Grid item xs={6}></Grid>
                {props.task.type ? (
                    <Grid item xs={12}>
                        {getInstance(props.task.type, {
                            options: options,
                            task: props.task,
                            tasks: props.tasks,
                            setOptions: setOptions,
                            setTasks: props.setTasks,
                            language: props.language,
                            languages: props.languages,
                            skills: props.skills,
                            taskTypes: props.taskTypes,
                        } as TaskTypeProps)}
                    </Grid>
                ) : (
                    ''
                )}
            </Grid>
        </div>
    );
};

export default TaskItem;
